import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import styles from './customTextFieldPassword.module.scss';

export const CustomTextFieldPassword = (props) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div>
            {props.isSavableAndCancelable === true ?
                <Form.Group className={styles.formText} controlId={props.controlId}>
                    <Form.Label
                        className={`${props.classLabel === 'defaultLabel' ? styles.defaultLabel : ''} `}>
                        {props.label}
                    </Form.Label>
                    <Form.Control
                        className={`${props.classType === 'defaultTextBox' ? styles.defaultTextBox : ''}`}
                        type={showPassword ? 'text' : 'password'}
                        placeholder={props.placeholder}
                        onChange={props.handleOnChange}
                        name={props.name}
                        isInvalid={props.isInvalid}
                        value={props.value}
                    />
                    {!showPassword && (
                        <span className={styles.eyeIcon}>
                            <i
                                className="fa fa-eye-slash"
                                onClick={() => setShowPassword(!showPassword)}>
                            </i>
                        </span>
                    )}
                    {showPassword && (
                        <span className={styles.eyeIcon}>
                            <i
                                className="fa fa-eye"
                                onClick={() => setShowPassword(!showPassword)}>
                            </i>
                        </span>
                    )}
                    {props.isLoading ?
                        <div className={styles.loadingIcon}>
                            <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                        </div>
                    : props.isOthersLoading?
                    null
                    :
                        <div>
                            <div className={styles.deleteIconDiv} onClick={props.onDeleteClick}>
                                <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke="#EB5757" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M11.25 6.75L6.75 11.25" stroke="#EB5757" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M6.75 6.75L11.25 11.25" stroke="#EB5757" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div className={styles.saveIconDiv} onClick={props.onSaveClick} itemType="submit">
                                <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H12L15.75 6V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75Z" stroke="#2DA6C0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12.75 15.75V9.75H5.25V15.75" stroke="#2DA6C0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M5.25 2.25V6H11.25" stroke="#2DA6C0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    }
                    <Form.Control.Feedback type="invalid" className={`${styles.errorDiv} ${styles.errorMsg}`}>
                        {props.errorMessage}
                    </Form.Control.Feedback>
                </Form.Group>
                :
                <Form.Group className={styles.formText} controlId={props.controlId}>
                    <Form.Label
                        className={`${props.classLabel === 'defaultLabel' ? styles.defaultLabel : ''} `}>
                        {props.label}
                    </Form.Label>
                    <Form.Control
                        className={`${props.classType === 'defaultTextBox' ? styles.defaultTextBox : ''}`}
                        type={showPassword ? 'text' : 'password'}
                        placeholder={props.placeholder}
                        onChange={props.handleOnChange}
                        name={props.name}
                        isInvalid={props.isInvalid}
                        value={props.value}
                    />
                    {!showPassword && (
                        <span className={styles.eyeIcon}>
                            <i
                                className="fa fa-eye-slash"
                                onClick={() => setShowPassword(!showPassword)}>
                            </i>
                        </span>
                    )}
                    {showPassword && (
                        <span className={styles.eyeIcon}>
                            <i
                                className="fa fa-eye"
                                onClick={() => setShowPassword(!showPassword)}>
                            </i>
                        </span>
                    )}
                    <Form.Control.Feedback type="invalid" className={`${styles.errorDiv} ${styles.errorMsg}`}>
                        {props.errorMessage}
                    </Form.Control.Feedback>
                </Form.Group>
            }
        </div>
    );
};

CustomTextFieldPassword.defaultProps = {
    classLabel: 'defaultLabel',
    classType: 'defaultTextBox'
};